declare const __APP_VERSION__: string
declare const __APP_BUILD_TIME__: string

const safeVersion = typeof __APP_VERSION__ === 'string'
  ? __APP_VERSION__
  : 'dev'
const safeBuiltAt = typeof __APP_BUILD_TIME__ === 'string'
  ? __APP_BUILD_TIME__
  : new Date().toISOString()

export const buildInfo: { version: string; builtAt: string } = {
  version: safeVersion,
  builtAt: safeBuiltAt,
}
